<ng-content></ng-content>
<!-- Rows emit their own click (e.g. media pickers); a toolbar click must not select the row. -->
<div
    *ngIf="showActions"
    class="row-hover-toolbar"
    role="toolbar"
    aria-label="Row actions"
    i18n-aria-label
    (click)="$event.stopPropagation()"
>
    <ng-content select="[rowHoverAction]"></ng-content>
</div>
